import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useTrail, animated } from 'react-spring';
import { useBusinessCard } from './BusinessCard';
import firebase from 'firebase/app';
import 'firebase/storage';
import styled from 'styled-components';
import { Dialog } from '@reach/dialog';
import '@reach/dialog/styles.css';
import { Checkbox, FormControlLabel, TextField, Typography } from '@material-ui/core';
import { createUser, sendClubEmail } from '../../core/models/user';
import { useSnackbar } from 'notistack';

const Container = styled.div`
  padding: 0rem 0.5rem;
  width: ${(p) => p.theme.dimensions.width}px;
`;
const config = { mass: 10, tension: 2000, friction: 200 };

const GridContainer = styled.div`
  width: 100%;
  column-gap: 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 1rem;
  align-content: center;
  justify-content: stretch;
  justify-items: stretch;
  padding-bottom: 4rem;
`;

const TextFieldContainer = styled.div`
  margin: 10px 28px;
`;

const CheckBoxContainer = styled.div`
  margin: 10px 28px;
`;

const ClubForm = ({ onDismiss }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [name, setName] = useState();
  const [phone, setPhone] = useState();
  const [email, setEmail] = useState();
  const [dob, setDob] = useState();
  const [agree, setAgree] = useState(false);

  const onSend = async () => {
    const res = await sendClubEmail({
      name, phone, email, dob,
    });
    if (res.data.status === 'ok') {
      enqueueSnackbar('הבקשה נשלחה בהצלחה', { variant: 'success' });
      onDismiss();
    } else {
      enqueueSnackbar('ארעה תקלה בעת משלוח מייל', { variant: 'error' });
    }
  };

  const formValid = name && email && agree;
  
  return (
    <>
      <StyledDialog isOpen={true} onDismiss={onDismiss}>
        <LighboxContainer>
          <LightboxHeader onClick={onDismiss}> חזרה לקטלוג </LightboxHeader>
          <LightboxDescription>
            הצטרפו למועדון הלקוחות ותהנו מהטבות והנחות בלעדיות!
          </LightboxDescription>
          <TextFieldContainer>
            <TextField
              onChange={(e) => setName(e.target.value)}
              fullWidth={true}
              placeholder={'שם'}
              helperText={'שם'}
            />
          </TextFieldContainer>
          <TextFieldContainer>
            <TextField
              fullWidth={true}
              onChange={(e) => setPhone(e.target.value)}
              placeholder={'טלפון'}
              helperText={'טלפון'}
            />
          </TextFieldContainer>
          <TextFieldContainer>
            <TextField
              onChange={(e) => setEmail(e.target.value)}
              fullWidth={true}
              placeholder={'אימייל'}
              helperText={'אימייל'}
            />
          </TextFieldContainer>
          <TextFieldContainer>
            <TextField
              fullWidth={true}
              onChange={(e) => setDob(e.target.value)}
              placeholder={'תאריך לידה'}
              helperText={'תאריך לידה'}
            />
          </TextFieldContainer>
          <CheckBoxContainer>
            <FormControlLabel
              color={'black'}
              control={
                <Checkbox
                  color="primary"
                  checked={agree}
                  style ={{
                    color: "black",
                  }}
                  onChange={(_, checked) =>
                    setAgree(checked)
                  }
                  name={'agree'}
                />
              }

              label={<Typography variant="h6" style={{ color: 'black' }}>מאשר דיוור</Typography>}
              labelPlacement="end"
            />
          </CheckBoxContainer>
          {formValid ? <LightboxButton onClick={() => onSend()}>הצטרפו למועדון</LightboxButton> : <LightboxButtonDisabled>הצטרפו למועדון</LightboxButtonDisabled>}
        </LighboxContainer>
      </StyledDialog>
    </>
  );
};

const StyledDialog = styled(Dialog)`
  width: ${(p) => p.theme.dimensions.vw(90)}px;
  max-height: ${(p) => p.theme.dimensions.vh(90)}px;
  padding: 0.2rem;
  overflow-y: scroll;
`;
const LighboxContainer = styled.div`
  display: grid;
  grid-template-rows: 5rem 3fr fit-content auto;
  font-family: ${(p) => p.theme.font};
`;
const LightboxHeader = styled.span`
  cursor: pointer;
  grid-row: 1;
  padding: 0rem 1.75rem;
  height: 2rem;
`;
const LightboxDescription = styled.p`
  width: ${(p) => p.theme.dimensions.vw(75)}px;
  font-size: 30px;
  justify-self: center;
  margin: 0.5rem 0px;
`;
const LightboxButton = styled.div`
  background-color: #111111;
  margin: 0.5rem;
  color: #f1f1f1;
  align-self: center;
  justify-self: center;
  padding: 1rem 3rem;
`;

const LightboxButtonDisabled = styled.div`
  background-color: #11111177;
  margin: 0.5rem;
  color: #f1f1f1;
  align-self: center;
  justify-self: center;
  padding: 1rem 3rem;
`;


const LBImageContainer = styled.div`
  align-self: center;
  justify-self: center;
  border: 2px solid #111111;
  padding: 0rem 0.5rem 0.5rem 0.5rem;
  display: grid;
  width: 75vw;
  grid-template-rows: 3rem auto 1rem;
  position: relative;
`;

const LBTitle = styled.span`
  grid-row: 3;
  text-align: center;
`;
const LBContact = styled.a`
  font-size: 0.8rem;
  color: #111111;
  grid-row: 1;
  justify-self: end;
  margin-left: 1.5rem;
`;
const LBImage = styled.img`
  width: 70vw;
  height: auto;
  grid-row: 2;
  justify-self: center;
  align-self: center;

  object-fit: contain;
`;
const LBWAI = styled.img`
  position: absolute;
  z-index: 50;
  top: -1.5rem;
  left: -1.5rem;
  width: 3rem;
  height: 3rem;
`;

const ContactMeTitle = styled.a`
  font-size: 0.9em;
  justify-self: start;
  text-align: right;
  margin-top: 0.5em;
  color: ${(p) => p.theme.textColor};
  width: 100%;
  grid-column: 2;
`;

const ProductTitle = styled.span`
  font-size: 1em;
  grid-column: 1/-1;

  color: ${(p) => p.color};
`;

export default ClubForm;

const ProductImgContainer = styled.div`
  color: ${(p) => p.theme.textColor};

  border: 1px solid ${(p) => p.theme.textColor};
  display: grid;
  align-self: stretch;
  align-content: center;
  grid-template-columns: 2rem auto;
  grid-template-rows: 2rem auto 2rem;
  border-style: solid;
  justify-self: stretch !important;
`;
